jQuery(function ($) {
  

  /*--------------------------모바일 메뉴 아코디언----------------------------*/
  $('.SidebarMenu__Nav>li:nth-child(3)').addClass('show');
  $('.SidebarMenu__Nav>li:nth-child(4)').addClass('show');
  $('.SidebarMenu__Nav > li:nth-child(3)').children('.dropdown-child_wrap').css('height','270px');
  $('.SidebarMenu__Nav > li:nth-child(4)').children('.dropdown-child_wrap').css('height','290px');
   $('.SidebarMenu__Nav > li').each(function(){
       if($(this).children('.dropdown-child_wrap').length > 0){
         $(this).children('a').attr('href','#');
         $(this).addClass('has_dropdown');
       }
   });
  $('.SidebarMenu__Nav > li> a').click(function(){
    if($(this).parent('li').find('.dropdown-child_wrap').length > 0){
      if($(this).parent('li').hasClass('show')){
        $(this).parent('li').removeClass('show');
        $(this).parent('li').find('.dropdown-child_wrap').css('height',0);
      }else{
        $('.dropdown-child_wrap').css('height',0);
        $('.SidebarMenu__Nav > li').removeClass('show');
        $(this).parent('li').addClass('show');
        var mo_dropdown_height = $(this).parent('li').find('.dropdown-child').outerHeight();
        $(this).parent('li').find('.dropdown-child_wrap').css('height',mo_dropdown_height);
      }
    }
  });

  $('.m_menu_close').click(function(){
    $('.SidebarMenu').removeClass('show');
  });
  
});